// extracted by mini-css-extract-plugin
export default {"root":"aSX36E","content":"NEquMY"};